import { apiDelete, apiGet, apiPost } from '@/shared/utils/requestBuilder';
import type { CriarGrupoDto, Grupo } from '@/types/grupo/grupoTypes';

const parse = async (response: Response, fallback: string): Promise<Grupo> => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: fallback }));
    throw new Error(errorData.error || fallback);
  }
  const result = await response.json();
  return result.data;
};

export const gruposAdminService = {
  listar: async (): Promise<Grupo[]> => {
    const response = await apiGet('/admin/grupos');
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao listar grupos' }));
      throw new Error(errorData.error || 'Erro ao listar grupos');
    }
    const result = await response.json();
    return result.data.items;
  },

  criar: async (data: CriarGrupoDto): Promise<Grupo> => {
    const response = await apiPost('/admin/grupos', data);
    return parse(response, 'Erro ao criar grupo');
  },

  vincular: async (grupoId: string, escritorioFilhoId: string): Promise<Grupo> => {
    const response = await apiPost(`/admin/grupos/${grupoId}/escritorios`, { escritorioFilhoId });
    return parse(response, 'Erro ao vincular escritório');
  },

  desvincular: async (grupoId: string, escritorioId: string): Promise<Grupo> => {
    const response = await apiDelete(`/admin/grupos/${grupoId}/escritorios/${escritorioId}`);
    return parse(response, 'Erro ao desvincular escritório');
  },

  consolidado: async (grupoId: string): Promise<Grupo> => {
    const response = await apiGet(`/grupos/${grupoId}/consolidado`);
    return parse(response, 'Erro ao carregar consolidado');
  },
};
